var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5273 10.4102H11.1953L16.75 15.9297C16.9609 16.1758 17.3125 16.1758 17.5234 15.9648C18.8945 14.6992 19.8086 12.9766 20.0898 11.0078C20.1602 10.6914 19.8789 10.4102 19.5273 10.4102ZM18.9648 8.125C18.6836 3.90625 15.3438 0.566406 11.125 0.285156C10.8086 0.25 10.5273 0.53125 10.5273 0.847656V8.72266H18.4023C18.7188 8.72266 19 8.44141 18.9648 8.125ZM8.83984 10.4102V2.04297C8.83984 1.72656 8.55859 1.44531 8.24219 1.48047C4.05859 2.07812 0.824219 5.73438 1 10.1289C1.14062 14.6289 5.00781 18.3203 9.50781 18.25C11.3008 18.25 12.918 17.6875 14.2891 16.7031C14.5703 16.5273 14.5703 16.1055 14.3242 15.8594L8.83984 10.4102Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.21545e32bbc91f278fa632bdebcab6b3.svg";
export { ForwardRef as ReactComponent };